import React from 'react';
import { Card, Switch, Space, Select, Typography } from 'antd';
import { NumberOutlined } from '@ant-design/icons';

const { Text } = Typography;
const { Option } = Select;

const SeatNumberControls = ({ 
  showSeatNumbers, 
  onToggleNumbers, 
  seatNumberColor, 
  onColorChange 
}) => {
  const colorOptions = [
    { value: '#374151', label: '默认灰', color: '#374151' },
    { value: '#1f2937', label: '深灰', color: '#1f2937' },
    { value: '#dc2626', label: '红色', color: '#dc2626' },
    { value: '#2563eb', label: '蓝色', color: '#2563eb' },
    { value: '#16a34a', label: '绿色', color: '#16a34a' },
    { value: '#ca8a04', label: '黄色', color: '#ca8a04' },
    { value: '#9333ea', label: '紫色', color: '#9333ea' },
    { value: '#c2410c', label: '橙色', color: '#c2410c' }
  ];

  return (
    <Card 
      title={
        <span>
          <NumberOutlined className="mr-2" />
          座位号设置
        </span>
      } 
      size="small"
      className="mt-4"
    >
      <Space direction="vertical" className="w-full">
        <div className="flex items-center justify-between">
          <Text>显示座位号</Text>
          <Switch 
            checked={showSeatNumbers} 
            onChange={onToggleNumbers}
            size="small"
          />
        </div>
        
        {showSeatNumbers && (
          <div>
            <Text className="block mb-2">角标颜色</Text>
            <Select 
              value={seatNumberColor}
              onChange={onColorChange}
              className="w-full"
              size="small"
            >
              {colorOptions.map(option => (
                <Option key={option.value} value={option.value}>
                  <div className="flex items-center gap-2">
                    <div 
                      className="w-3 h-3 rounded-full border"
                      style={{ backgroundColor: option.color }}
                    />
                    <span>{option.label}</span>
                  </div>
                </Option>
              ))}
            </Select>
          </div>
        )}
        
        <div className="text-xs text-gray-500 mt-2">
          座位号显示在每个座位的右下角，便于快速定位学生座位
        </div>
      </Space>
    </Card>
  );
};

export default SeatNumberControls;
